import { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";

import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import SubjectList from "../../shared/domain/learning/components/SubjectList.jsx";

import { GlobalContext } from "../../context/GlobalState.jsx";
import { fixName } from "../helpers.js";

export default function Subjects() {
  const { userDetails, setUserDetails, allSubjects, subLoading,gradeSection } =
    useContext(GlobalContext);
  const history = useHistory();

  useEffect(() => {
    setUserDetails({ ...userDetails, selectedTab: "My Assessment" });
    setUserDetails({
      ...userDetails,
      selectedPath: {
        subject: "",
        chapter: "",
        topic: "",
      },
    });
  }, []);

  const openSubject = (subject) => {
    history.push(
      `/myassessment/practice/subjects/${subject.subjectId}/${fixName(
        subject.subject,
      )}/chapters`,
    );
  };

  return (
    <LearningContentLayout
      grade={gradeSection}
       page={"Practice Assessment"}
      resourcePage={"Subjects"}
    >
      <SubjectList
        subjects={allSubjects}
        loading={subLoading}
        onClick={openSubject}
      />
    </LearningContentLayout>
  );
}
